export function downloadBlob(blob: any, fileName: string) {

    let newBlob = new Blob([blob], {type: 'text/csv'});

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, fileName);
        return;
    }

    const data = window.URL.createObjectURL(newBlob);

    let link = document.createElement('a');
    link.href = data;
    link.download = fileName;
    link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

    setTimeout(() => {
        window.URL.revokeObjectURL(data);
        link.remove();
    }, 100);

}

export function openPdfInNewTab(blob: Blob, targetWindow?: Window | null): void {
    const pdfBlob = blob.type === 'application/pdf'
        ? blob
        : new Blob([blob], {type: 'application/pdf'});
    const url = window.URL.createObjectURL(pdfBlob);
    const previewWindow = targetWindow || window.open('', '_blank');

    if (!previewWindow) {
        window.URL.revokeObjectURL(url);
        return;
    }

    previewWindow.opener = null;
    previewWindow.location.href = url;
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
}
